import React from 'react';
import { motion } from 'framer-motion';
import { Users, Handshake, TrendingUp } from 'lucide-react';

const features = [
  {
    icon: Users,
    title: '4-7 Players',
    description:
      'Perfect for game night. Play with a full table of friends or family.',
  },
  {
    icon: Handshake,
    title: 'Finding Friends',
    description:
      "Hidden teams revealed mid-game. Who's your ally? Strategic deduction meets card play.",
  },
  {
    icon: TrendingUp,
    title: 'Level Up',
    description:
      'Progress from 2 to Ace. Win rounds to advance your rank and become the dealer.',
  },
];

export function Features() {
  return (
    <section className="py-16 bg-gray-50 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-black mb-4">
            Why Shengji?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{
                opacity: 0,
                y: 20,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              viewport={{
                once: true,
              }}
              transition={{
                delay: index * 0.1,
                duration: 0.5,
              }}
              className="bg-white p-6 rounded-lg border border-gray-200 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
            >
              <div className="w-10 h-10 bg-red/10 rounded-lg flex items-center justify-center mb-4 text-red">
                <feature.icon className="w-5 h-5" />
              </div>
              <h3 className="text-lg font-bold text-black mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
